<template>
  <div class="home">
    <Topo @selecionar-assinatura="selecionarAssinatura" />
    <div class="row">
      <div class="col-md-4 mt-3">
        <Menu/>
      </div>
      <!-- Conteudo das views -->
      <div class="col-md-8 mt-3" v-if="subscription.typeSub == 'PJ'">
          <table class="table table-responsive">
            <tbody>
                <tr v-for="life in lifes" :key="life.holder.id">
                    <td>{{life.holder.name}}  <br> (CPF: {{life.holder.cpfCnpjFmt}})</td>
                    <td>    
                            <table class="table table-responsive font-tabela-peq">
                                <thead class="thead">
                                    <tr>
                                        <th scope="col">Nome</th>
                                        <th scope="col">Tipo</th>
                                        <th scope="col">Cartão</th>
                                        <th scope="col">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="card in life.cards" :key="card.token">
                                        <td>
                                            <span v-if="card.isCardOfHolder">{{card.holder.name}}</span>
                                            <span v-else>{{card.dependent.name}}</span>
                                        </td>
                                        <td>
                                            <span v-if="card.isCardOfHolder">Titular</span>
                                            <span v-else>Dependente</span>
                                        </td>
                                        <td>
                                            {{card.numberOnCard}}
                                        </td>
                                        <td>
                                            <span v-show="card.status == 'BLOCKED'"> BLOQUEADO</span>
                                            <span v-show="card.status == 'OK'">ATIVO</span>
                                            <span v-show="card.status == 'CANCELED'">
                                                CANCELADO<br>
                                                (Em {{card.dateCancel}})
                                            </span>
                                            <span v-show="card.status == 'EXPIRED'">EXPIRADO</span>
                                            <span v-show="card.status == 'BLOCKED_BY_FRAUD'">BLOQUEADO POR FRAUDE</span>
                                        </td>
                                    </tr>
                                    <tr v-show="lifes == null">
                                        <td>
                                            Nenhum titular disponível.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                    </td>
                </tr>
                <tr v-show="lifes == null">
                    <td>
                        Nenhum beneficiário disponível.
                    </td>
                </tr>
            </tbody>
          </table>
      </div>

      <div class="col-md-8 mt-3" v-if="subscription.typeSub == 'PF'">
        <MensagemAssinaturaNaoDisponivel :subscription="subscription"/>

        <div
          class="card back-card col-md-12 rounded mb-4"
          v-for="card in cards"
          :key="card.id" v-show="card.status != 'CANCELED'">
          <div class="card-body" >
            <p class="card-title">
              <img src="@/assets/logo_white_to_card.png" width="200">
            </p>
            <h3 class="card-text text-white mt-5">
              <strong>{{card.numberOnCard}}</strong>
            </h3>
            <p v-show="card.status == 'BLOCKED'" class="card-subtitle ml-4 mt-2 text-white font-weight-bold"> BLOQUEADO</p>
            <p v-show="card.status == 'OK'" class="card-subtitle ml-4 mt-2 text-white font-weight-bold">ATIVO</p>
            <p v-show="card.status == 'CANCELED'" class="card-subtitle ml-4 mt-2 text-white font-weight-bold">CANCELADO</p>
            <p v-show="card.status == 'EXPIRED'" class="card-subtitle ml-4 mt-2 text-white font-weight-bold">EXPIRADO</p>
            <p v-show="card.status == 'BLOCKED_BY_FRAUD'" class="card-subtitle ml-4 mt-2 text-white font-weight-bold">BLOQUEADO</p>

            <div class="row">
                <div class="col-md-8 mt-4">
                     <h4 class="card-title text-left ml-4 text-white">{{card.nameOnCard}}</h4>
                    <span class="card-title text-left ml-4 text-white " v-if="card.isCardOfHolder">
                        <strong>Titular</strong>
                    </span>
                    <span class="card-title text-left ml-4 text-white" v-else>
                        <strong>Dependente</strong>
                    </span>
                </div>    
                 <div class="card-body ml-5">
                     <p>
                        <img
                           :src="card.qrcode"
                            width="120"
                            height="120"
                            >
                    </p>
                </div>    
            </div>    
           
           
          </div>
        </div>
      </div>
      <!--Fim conteudo view -->
    </div>
    <Rodape/>
  </div>
</template>

<script>
import Topo from "@/components/Topo.vue";
import Rodape from '@/components/Rodape.vue'
import Menu from "@/components/Menu.vue";
import MensagemAssinaturaNaoDisponivel from "@/components/MensagemAssinaturaNaoDisponivel.vue";

const optionsAlert = { title: "Mensagem", size: "sm" };

export default {
  created(){
     //redirect to https ambiance
    if(location.href.indexOf("localhost") < 0 && location.href.indexOf("https") < 0 && location.href.indexOf("192.168.0.11") < 0){
        location.href = location.href.replace("http","https");
    }
  },
	name: "home",
	components: {
		Topo,
    Rodape,
		Menu,
		MensagemAssinaturaNaoDisponivel
	},
	data() {
		return {
			subscription: { typeSub: null },
			cards: null,
			lifes: [],
			selecionadaSubscription: 0
		};
	},
	methods: {
		loadLifes(idSubscription){
			this.$clubApi.get('/subscription/'+ idSubscription +'/list/group/lifes')
			.then(response => {
				this.lifes = response.data.object;
			}).catch(error => {
				this.$notify({type: 'warning', message: error.response.data.msg})
			}).finally(() => {
				//NProgress.done();
			});
		},
		loadCardsData(idSubscription) {
			this.$clubApi.get("/subscription/list/cards/"+ idSubscription).then(response => {
				this.cards = response.data.object;
			}).catch(error => {
				this.$dialogs.alert(error.response.data.msg, optionsAlert);
			});
		},
		carregarAssinatura(idSubscription) {
			if (idSubscription !== undefined) {
				this.$clubApi.get("/subscription/load/"+ idSubscription).then(response => {
					this.loadCardsData(idSubscription);
					this.subscription = response.data.object;
				}).catch(error => {
					if (error.response.data.msg === "NewUser") {
						location.href = '/assinatura/concluir'
					} else {
						this.$dialogs.alert(error.response.data.msg, optionsAlert);
					}
				}).finally(() => {
					NProgress.done();
					if(this.subscription.typeSub == 'PJ'){
						this.loadLifes(this.selecionadaSubscription)
					}
				});
			}
		},
		selecionarAssinatura(idSubscription) {
      this.lifes = [];
      this.cards = [];
			this.selecionadaSubscription = (idSubscription===undefined) ? 0 : idSubscription;
			this.carregarAssinatura(this.selecionadaSubscription);
		}
	}
};
</script>

<style scoped>
.rounded {
  border-radius: 1.00rem !important;
}
</style>

